document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'shopify_wishlist';
  
  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  }
  
  function setWishlist(arr) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    // Dispatch event so all parts of the UI can update
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: arr }));
  }
  
  function toggleWishlist(handle) {
    let wishlist = getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
    } else {
      wishlist.push(handle);
    }
    setWishlist(wishlist);
  }

  // Sync the UI (Buttons and Header Counter)
  function syncUI() {
    const wishlist = getWishlist();
    
    // 1. Sync all buttons on the page
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const emptyHeart = btn.querySelector('.heart-empty');
      const filledHeart = btn.querySelector('.heart-filled');
      const textSpan = btn.querySelector('.wishlist-btn-text');
      
      if (wishlist.includes(handle)) {
        if(emptyHeart) emptyHeart.style.display = 'none';
        if(filledHeart) filledHeart.style.display = 'block';
        if(textSpan) textSpan.textContent = 'İstek Listemden Çıkar';
      } else {
        if(emptyHeart) emptyHeart.style.display = 'block';
        if(filledHeart) filledHeart.style.display = 'none';
        if(textSpan) textSpan.textContent = 'İstek Listeme Ekle';
      }
    });

    // 2. Sync Header Counter
    const countBubble = document.getElementById('wishlist-count');
    if (countBubble) {
      const countSpan = countBubble.querySelector('span');
      if (wishlist.length > 0) {
        countBubble.style.display = 'flex';
        countSpan.textContent = wishlist.length;
      } else {
        countBubble.style.display = 'none';
      }
    }
  }

  // Global event delegation for any clicks on a wishlist button
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-btn');
    if (btn) {
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) toggleWishlist(handle);
    }
  });

  // Listen for local updates and cross-tab updates
  document.addEventListener('wishlist:updated', syncUI);
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) syncUI();
  });
  
  syncUI(); // Initial run

  // --- Wishlist Grid Logic ---
  const gridContainer = document.getElementById('wishlist-grid');
  if (gridContainer) {
    const loader = document.getElementById('wishlist-loader');
    const emptyMsg = document.getElementById('wishlist-empty');
    
    async function renderGrid() {
      const handles = getWishlist();
      gridContainer.innerHTML = '';
      
      if (handles.length === 0) {
        loader.style.display = 'none';
        gridContainer.style.display = 'none';
        emptyMsg.style.display = 'block';
        return;
      }
      
      emptyMsg.style.display = 'none';
      loader.style.display = 'block';
      gridContainer.style.display = 'none';

      const rootUrl = window.Shopify?.routes?.root || '/';
      const products = await Promise.all(
        handles.map(async (handle) => {
          try {
            const res = await fetch(`${rootUrl}products/${handle}.js`);
            return res.ok ? await res.json() : null;
          } catch (e) { return null; }
        })
      );

      loader.style.display = 'none';
      gridContainer.style.display = 'flex'; 
      
      const currency = window.Shopify?.currency?.active || 'USD';
      const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency });

      products.filter(p => p).forEach(product => {
        const price = formatter.format(product.price / 100);
        const img = product.featured_image 
            ? product.featured_image.replace(/\.(png|jpg|jpeg|gif|webp)/i, '_600x.$1') 
            : '';
        
        // Injecting Dawn-compatible DOM structure
        gridContainer.innerHTML += `
          <div class="grid__item" id="wishlist-item-${product.handle}">
            <div class="card-wrapper underline-links-hover">
              <div class="card card--standard card--media">
                <div class="card__inner color-background-2 ratio" style="--ratio-percent: 100%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <img src="${img}" alt="${product.title}" loading="lazy" class="motion-reduce" width="600" height="600" style="position: relative !important;">
                    </div>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                      <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                    </h3>
                    <div class="price">
                      <span class="price-item price-item--regular">${price}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="button button--secondary wishlist-btn" data-product-handle="${product.handle}" style="margin-top: 1rem; width: 100%;">
                <span class="wishlist-btn-text">İstek Listemden Çıkar</span>
              </button>
            </div>
          </div>
        `;
      });
    }

    renderGrid();
    
    // Smooth removal without re-rendering the whole grid
    document.addEventListener('wishlist:updated', (e) => {
       const handles = e.detail;
       if (handles.length === 0) {
           renderGrid(); // Trigger empty state
       } else {
           document.querySelectorAll('[id^="wishlist-item-"]').forEach(el => {
               const itemHandle = el.id.replace('wishlist-item-', '');
               if (!handles.includes(itemHandle)) el.remove();
           });
       }
    });
  }
});